import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/image/JZ-white.png';
import _imports_1 from '@/assets/image/zuzhi1.png';
const _hoisted_1 = {
  class: "about-header"
};
const _hoisted_2 = {
  class: "display-space-between"
};
const _hoisted_3 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_4 = {
  class: "display-space-between"
};
const _hoisted_5 = {
  class: "display-space-between"
};
const _hoisted_6 = {
  style: {
    "font-size": "14px",
    "color": "#2c82f8"
  }
};
const _hoisted_7 = {
  class: "about-box"
};
const _hoisted_8 = {
  title: "全屏/正常",
  class: "about-item"
};
const _hoisted_9 = {
  class: "about-item mr10"
};
const _hoisted_10 = {
  class: "borderb"
};
const _hoisted_11 = {
  class: "pb10 pt5",
  style: {
    "text-align": "center"
  }
};
import { computed } from "vue";
import { Zh_CNName } from "@/types/index";
import Fullscreen from "@/components/layout/Fullscreen.vue";
import router from "@/router";
import store from "@/store";
export default {
  __name: 'HeadNavbar',
  setup(__props) {
    const _close = () => router.push("/devices");
    const _title = computed(() => {
      let route = router.currentRoute.value;
      return Zh_CNName[route.name.toLocaleUpperCase()];
    });
    const _name = computed(() => store.state.workspace?.platform_name);
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("div", null, [_createElementVNode("div", {
        class: "about-title"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        style: {
          "width": "60px",
          "height": "60px",
          "margin": "10px 5px 10px 25px"
        }
      }), _createElementVNode("p", {
        style: {
          "font-size": "28px",
          "line-height": "0",
          "width": "160px"
        }
      }, "组织管理")])], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[0] || (_cache[0] = _createElementVNode("i", {
        class: "iconfont icon-fold p10 ml5"
      }, null, -1)), _createElementVNode("p", _hoisted_6, _toDisplayString(_title.value), 1)]), _createElementVNode("ul", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("li", {
        title: "消息",
        class: "about-item"
      }, [_createElementVNode("i", {
        class: "iconfont icon-naozhongxiaoxitixing"
      })], -1)), _createElementVNode("li", _hoisted_8, [_createVNode(Fullscreen)]), _createElementVNode("li", _hoisted_9, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "flex-column"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, _toDisplayString(_name.value), 1)]), _createVNode(_component_el_dropdown_item, {
            onClick: _close
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("退出组织管理")])),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("div", {
          style: {
            "border-radius": "50%"
          }
        }, [_createElementVNode("img", {
          src: _imports_1,
          style: {
            "width": "40px",
            "height": "40px"
          }
        })], -1))]),
        _: 1
      })])])])])])]);
    };
  }
};